import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from '../../components/Sidebar';
import HeaderGlobal from '../../components/HeaderGlobal';
import SearchFilters from './SearchFilters';
import StudentResults from './StudentResults';
import StudentDetail from './StudentDetail';
import { getStudentsPaged } from '../../api/students';
import { getCampus } from '../../api/campus';
import styles from '../../styles/BajaReactivacionStyles/BajaReactivacion.module.css';

const PAGE_SIZE = 15;

function BajaReactivacionScreen() {
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [appliedSearch, setAppliedSearch] = useState('');
  const [filters, setFilters] = useState({ seccion: '' });

  // Campus global: nombre (para HeaderGlobal) e ID (para la API)
  const [selectedCampus, setSelectedCampus] = useState(() => localStorage.getItem('selectedCampus') || '');
  const [campusId, setCampusId] = useState(null);

  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Sincronizar campus nombre e ID (igual que EstudiantesScreen)
  useEffect(() => {
    const resolveCampusId = async (campusNombre) => {
      if (!campusNombre || campusNombre === 'Todos') { setCampusId(null); return; }
      try {
        const lista = await getCampus();
        const found = lista.find(
          (c) => c.nombre?.toLowerCase() === campusNombre.toLowerCase()
        );
        setCampusId(found?.id || null);
      } catch { setCampusId(null); }
    };

    const storedCampus = localStorage.getItem('selectedCampus') || '';
    setSelectedCampus(storedCampus);
    resolveCampusId(storedCampus);

    const handleCampusChanged = (e) => {
      const nombre = e?.detail?.campus || localStorage.getItem('selectedCampus') || '';
      setSelectedCampus(nombre);
      resolveCampusId(nombre);
    };
    const handleStorage = () => {
      const nombre = localStorage.getItem('selectedCampus') || '';
      setSelectedCampus(nombre);
      resolveCampusId(nombre);
    };
    window.addEventListener('campusChanged', handleCampusChanged);
    window.addEventListener('storage', handleStorage);
    return () => {
      window.removeEventListener('campusChanged', handleCampusChanged);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  const fetchStudents = useCallback(async (currentPage = 1) => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        page_size: PAGE_SIZE,
      };
      if (campusId) params.id_campus = campusId;
      if (filters.seccion) params.id_seccion = filters.seccion;
      if (appliedSearch) params.search = appliedSearch;

      const data = await getStudentsPaged(params);
      setStudents(data.results || []);
      setTotalPages(data.total_pages || 1);
    } catch { setStudents([]); }
    finally { setLoading(false); }
  }, [campusId, filters.seccion, appliedSearch]);

  // Recargar al cambiar campus, filtros o página
  useEffect(() => {
    fetchStudents(page);
  }, [fetchStudents, page]);

  const handleBuscar = () => {
    setAppliedSearch(searchTerm);
    setPage(1);
  };

  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({ ...prev, [filterType]: value }));
    setPage(1);
  };

  const handleStudentSelect = (student) => setSelectedStudent(student);
  const handleBackToSearch = () => {
    setSelectedStudent(null);
    fetchStudents(page);
  };

  return (
    <div className={styles.layout}>
      <div className={styles.sidebarColumn}>
        <Sidebar />
      </div>
      
      <div className={styles.contentColumn}>
        <HeaderGlobal
          title="Baja/Reactivación de Estudiante"
          campus={selectedCampus}
          onCampusChange={e => setSelectedCampus(e.target.value)}
        />
        <div className={styles.contentArea}>
          <div className={styles.contentWrapper}>
            {!selectedStudent ? (
              <>
                <SearchFilters
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  searchTerm={searchTerm}
                  onSearch={setSearchTerm}
                  onBuscar={handleBuscar}
                />
                <StudentResults
                  students={students}
                  onStudentSelect={handleStudentSelect}
                  loading={loading}
                  page={page}
                  totalPages={totalPages}
                  onPageChange={(newPage) => setPage(newPage)}
                />
              </>
            ) : (
              <StudentDetail
                student={selectedStudent}
                onBack={handleBackToSearch}
                onSaved={handleBackToSearch}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BajaReactivacionScreen;
